<template>
    <div>
        <form class="form-horizontal" >

            <div class="form-group">

                <div class="col-sm-12">
                    <label class="control-label">NOME DO CLIENTE</label>
                    <input disabled type="text" v-model="contrato.cliente.nome" class="form-control" >
                </div>

            </div>

            <button @click="traceroute()" type="button" :disabled="texto" class="btn btn-success">EXECUTAR TRACEROUTE</button>

            <br/>
            <h3>{{ texto }}</h3>

            <pre>
                <ul>
                    <li v-bind:key="t" v-for="t in data">{{ t }}</li>
                </ul>
            </pre>

        </form>

    </div>
</template>
<script>
/* global io */
import contratoMixin from "../../mixins/contrato";
export default {
    mixins: [contratoMixin],
    data() {
        return {
            socket: null,
            texto: null,
            data: []
        };
    },
    mounted() {
        this.socket = io.connect(
            this.$http.options.root,
            { reconnect: true, transports: ["websocket", "polling"] }
        );
        this.socket.on("news", data => {
            console.log(data);
            this.socket.emit("my other event", { my: "data" });
        });
        this.socket.on("traceroute", data => {
            this.texto = data.data;
            this.data = [];
        });
        this.socket.on("traceroute-end", data => {
            this.data = data.data;
            this.texto = null;
        });
    },
    beforeDestroy() {
        this.socket.close();
    },
    methods: {
        traceroute() {
            this.socket.emit("traceroute", { contrato_id: this.contrato._id });
        }
    }
};
</script>
